<template>
  <div>
    <div v-if="schema.information && schema.information.$model">
      <div v-html="schema.information.$model" />
    </div>

    <div v-for="valueName in valuesInSchema" :key="valueName" class="mt-4">
      <div v-if="schema.values[valueName].passed">
        <div v-if="schema.values[valueName].$title">{{ schema.values[valueName].$title }}</div>

        <div class="d-flex flex-wrap">
          <w-radio
            v-for="enumValue in schema.values[valueName].passed.$enum"
            :key="'criterion_passed_' + enumValue"
            class="mr-3"
            :title="FormalAssessmentValueTranslations[enumValue]"
            :model="schema.values[valueName].passed"
            :value="enumValue"
          />
        </div>
      </div>

      <w-input v-else-if="schema.values[valueName].number" class="mt-4" :model="schema.values[valueName].number" />

      <yes-or-no-radio v-else-if="schema.values[valueName].bool" class="mt-4" :model="schema.values[valueName].bool" />

      <w-input v-else-if="schema.values[valueName].value" class="mt-4" :model="schema.values[valueName].value" />

      <w-datepicker v-else-if="schema.values[valueName].date" class="mt-4" :model="schema.values[valueName].date" />

      <w-input v-else class="mt-4" :model="schema.values[valueName]" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { FormalAssessmentValueTranslations } from '@/enums/formalAssessmentValue.enum';

import YesOrNoRadio from '../document/YesOrNoRadio.vue';

// @vuese
// Ustawienie wartości dokumentu
// @group ActionData
export default {
  components: { ...components, YesOrNoRadio },
  props: {
    /** Schema */
    schema: { type: Object, required: false }
  },
  data() {
    return { i18nPath: '', FormalAssessmentValueTranslations };
  },
  computed: {
    valuesInSchema() {
      return Object.keys(this.schema.values.$model);
    }
  }
};
</script>
